type AdvertiserUrl = {
  id: number
  endHost: string
}

type Domain = {
  id: number
  text: string
}

export const mapUrlsToDomains = (urls: AdvertiserUrl[]): Domain[] =>
  urls.map((url) => ({ id: url.id, text: url.endHost }))

export const formatDomain = (domain: string): string =>
  domain
    .replace(/www\./gi, '')
    .replace(/https:\/\//gi, '')
    .replace(/http:\/\//gi, '')
